import ViewPadrao from "../views/ViewPadrao";
import GrupoItemList from "../views/GrupoItemList";
import GrupoItemCad from "../views/GrupoItemCad";

export default {
  path: "grupo-item",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "grupo-item-list",
      component: GrupoItemList
    },
    {
      path: "novo",
      name: "grupo-item-formulario",
      component: GrupoItemCad
    },
    {
      path: "editar/:id",
      name: "grupo-item-formulario-editar",
      component: GrupoItemCad
    }
  ]
};
